/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const CaseLower = [
  ["path", { d: "M10 9v7" }],
  ["path", { d: "M14 6v10" }],
  ["circle", { cx: "17.5", cy: "12.5", r: "3.5" }],
  ["circle", { cx: "6.5", cy: "12.5", r: "3.5" }]
];

export { CaseLower as default };
//# sourceMappingURL=case-lower.js.map
